import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import NoData from '@/components/common/no-data/NoData';
import NewBookingSectionVp from '@/components/common/sections/bookings/new-booking-section-vp/NewBookingSectionVp';
import ChooseDateTimeStep from '@/components/section/new-booking/choose-date-time-step/ChooseDateTimeStep';
import ChooseServiceDivisionStep from '@/components/section/new-booking/choose-service-divison-step/ChooseDateTimeStep';
import ChooseServiceStep from '@/components/section/new-booking/choose-service-step/ChooseServiceStep';
import FinalMessage from '@/components/section/new-booking/final-message/FinalMessage';
import ParticipantsDataStep from '@/components/section/new-booking/participants-data-step/ParticipantsDataStep';
import Stepper from '@/components/section/new-booking/stepper/Stepper';
import { Skeleton } from '@/components/ui/skeleton';
import useGetOrganization from '@/hooks/queries/organization-api/useGetOrganization';
import { VEPCodes } from '@/lib/utils';
import { useRootStore } from '@/stores/root-store';
import { useEffect } from 'react';

const NewBookingPage = () => {
  const currentStep = useRootStore((store) => store.currentStep);
  const stepServicesData = useRootStore((store) => store.stepServicesData);
  const setStep = useRootStore((store) => store.setStep);
  const cleanStepServicesData = useRootStore(
    (store) => store.cleanStepServicesData
  );
  // reset the step progressive bar
  useEffect(() => {
    setStep(1);
    cleanStepServicesData();
    return () => {
      setStep(1);
      cleanStepServicesData();
    };
  }, [cleanStepServicesData, setStep]);

  const organization = useGetOrganization();

  const serviceHasRangeDivisions =
    stepServicesData?.service?.rangeDivisions?.length &&
    stepServicesData?.service?.rangeDivisions?.length > 0;

  if (organization.isPending) {
    return (
      <div className="flex flex-col w-full gap-8">
        <Skeleton className="w-full h-8" />
        <div className="flex flex-col items-center w-full gap-6">
          <Skeleton className="w-11/12 h-8 " />
          <Skeleton className="w-11/12 h-8 " />
          <Skeleton className="w-11/12 h-8 " />
          <Skeleton className="w-11/12 h-8 " />
        </div>
      </div>
    );
  }
  if (!organization.data) return <NoData />;
  if (organization.isError) {
    return <ErrorMessage />;
  }

  if (VEPCodes.includes(organization.data.code)) {
    return <NewBookingSectionVp organization={organization.data} />;
  }
  return (
    <div className="w-full">
      <Stepper totalSteps={4} />
      <div className="container mt-8 mb-14">
        {currentStep === 1 && (
          <ChooseServiceStep organization={organization.data} />
        )}
        {currentStep === 2 ? (
          serviceHasRangeDivisions ? (
            <ChooseServiceDivisionStep organization={organization.data} />
          ) : (
            <ChooseDateTimeStep organization={organization.data} />
          )
        ) : null}
        {currentStep === 3 && (
          <ParticipantsDataStep organization={organization.data} />
        )}
        {currentStep === 4 && <FinalMessage />}
      </div>
    </div>
  );
};

export default NewBookingPage;
